import {
    createNavigationContainerRef,
} from '@react-navigation/native';

const navigationRef = createNavigationContainerRef();
export default navigationRef;
